var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("403 Unauthorized")]),_c('p',[_vm._v("您将在 "+_vm._s(_vm.countdown)+" 秒后被重定向到主页。")])])
}
var staticRenderFns = []

export { render, staticRenderFns }